import getStore from '../store';

export default function loading(): boolean {
    const store = getStore();
    return store.loading > 0;
}
